import NTopNBottom from "../../components/NTopNBottom";

import bannerImg from "../../assets/girlDream/banner.jpg";
import navColor from "../../assets/girlDream/nav/color.jpg";
import navBgFixed from "../../assets/girlDream/nav/nav_bg_fixed.png";

import far1 from "../../assets/girlDream/nav/far1.png";
import far1_active from "../../assets/girlDream/nav/far1_active.png";
import far2 from "../../assets/girlDream/nav/far2.png";
import far2_active from "../../assets/girlDream/nav/far2_active.png";
import far3 from "../../assets/girlDream/nav/far3.png";
import far3_active from "../../assets/girlDream/nav/far3_active.png";
import far4 from "../../assets/girlDream/nav/far4.png";
import far4_active from "../../assets/girlDream/nav/far4_active.png";

import calcRemFn from "../calcRem";

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(86),
    backgroundImage: `url(${navColor})`,
    boxSizing: "border-box"
  },
  navCtnFixed: {
    height: calcRemFn(86),
    backgroundImage: `url(${navBgFixed})`
  },
  topBtnLayout: {
    alignItems: "center",
    paddingTop: `${calcRemFn(25)}`,
    paddingLeft: `${calcRemFn(37)}`,
    paddingRight: `${calcRemFn(32.5)}`
  },
  topBtnBaseCss: {
    width: calcRemFn(63.5),
    height: calcRemFn(19)
  },
  bottomBtnLayout: {
    justifyContent: "center",
    padding: `${calcRemFn(17)} ${calcRemFn(38)} 0 ${calcRemFn(49.5)}`
  },
  bottomBtnBaseCss: {
    width: calcRemFn(70),
    height: calcRemFn(16)
  }
};

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: "top1",
      show: true,
      img: far1,
      img_actived: far1_active
    },
    {
      key: "top2",
      show: true,
      img: far2,
      img_actived: far2_active
    },
    {
      key: "top3",
      show: true,
      img: far3,
      img_actived: far3_active
    },
    {
      key: "top4",
      show: true,
      img: far4,
      img_actived: far4_active
    }
  ],
  bottom: {
    top1: {
      start: 0,
      num: 4
    },
    top2: {
      start: 0,
      num: 4
    },
    top3: {
      start: 4,
      num: 2
    },
    top4: {
      start: 6,
      num: 6
    }
  }
};

const bottomList = navData.bottom;

for (const key in bottomList) {
  let { start, num } = bottomList[key];
  let list = [];

  new Array(num).fill(1).forEach((item, index) => {
    list.push({
      key: "_i" + (index + 1),
      show: true,
      img: require(`../../assets/girlDream/nav/son${start + index + 1}.png`),
      img_actived: require(`../../assets/girlDream/nav/son${start + index + 1}_active.png`)
    });
  });

  bottomList[key] = list;
}


const pictureList = [
  {
    key: "1_1",
    pid: 93193,
    picNum: 5,
  },
  {
    key: "1_2",
    pid: 93193
  },
  {
    key: "1_3",
    pid: 93193
  },
  {
    key: "1_4",
    pid: 93193
  },
  {
    key: "2_1",
    pid: 93193
  },
  {
    key: "2_2",
    pid: 93193,
  },
  {
    key: "2_3",
    pid: 93193,
    picNum: 3
  },
  {
    key: "2_4",
    pid: 93193,
  },
  {
    key: "3_1",
    pid: 27184,
    picNum: 3
  },
  {
    key: "3_2",
    pid: 27184,
  },
  {
    key: "4_1",
    pid: 27184,
    picNum: 4
  },
  {
    key: "4_2",
    pid: 27184,
  },
  {
    key: "4_3",
    pid: 27184,
  },
  {
    key: "4_4",
    pid: 27184,
  },
  {
    key: "4_5",
    pid: 27184,
    picNum: 1
  },
  {
    key: "4_6",
    pid: 27184,
    picNum: 1
  },
];

function handlePictures(pictureList) {
  const pictures = [];
  pictureList.forEach(item => {
    const { picNum = 2, pid, key, startIndex = 0, type = "gold", fun } = item;
    const picList = [];
    Array(picNum)
      .fill(0)
      .forEach((item, index) => {
        picList.push(require(`../../assets/girlDream/ctn/${key}_${index + startIndex + 1}.jpg`));
      });
    const indexArr = key.split("_");
    pictures.push({
      id: pid,
      type,
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList,
      ...(fun && { fun })
    });
  });
  return pictures;
}
const pictures = handlePictures(pictureList);

const topDiff = {
  firstSon: "_i1",
  // top1_i1: 15,
  top4_i2: 10,
  // top2_i2: 55,
  // top2_i3: 55,
};

export default {
  title: "一人婚纱梦",
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
};
